import React, {useRef, useState} from 'react';
import styled from 'styled-components';
import {BookmarksOutlined} from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';
import {TrackedPreview} from './TrackedPreview';
import {useRestockedTrackedProducts} from '../application/useRestockedTrackedProducts';
import {useClickOutside} from '../../helpers/hooks/useClickOutside';

const ItemsCounter = styled.div`
  border-radius: .25rem;
  cursor: pointer;
  border: none;
  height: 50px;
  display: flex;
  align-items: center;
  position: relative;

  :after {
    content: attr(data-count);
    min-width: 1.2rem;
    min-height: 1.2rem;
    margin-left: .25rem;
    border-radius: 50%;
    display: ${({hideBadge}) => (hideBadge ? 'none' : 'flex')};
    align-items: center;
    justify-content: center;
    font-size: 12px;
    background: var(--bs-warning);
    color: white;
  }
`;

const Content = styled.div`
  position: fixed;
  background-color: var(--bs-white);
  min-width: 50%;
  max-width: 100%;
  max-height: calc(100vh - 100px);
  overflow: auto;
  right: 0;
  box-shadow: 0 8px 16px 0 rgb(0 0 0 / 20%);
  z-index: 2;
  padding: 1rem;
  border-radius: 10px;
`;

const CloseBtnContainer = styled.button`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  position: absolute;
  right: .5rem;
  top: 1rem;
  border: none;
  color: white;
  background-color: var(--bs-primary);
  opacity: 0.5;

  svg {
    width: 1rem;
  }
`;

/**
 * Botón del navbar que abre el panel de productos pendientes,
 * equivalente al CartPreviewButton del carrito. El badge indica
 * cuántos pendientes vuelven a tener stock suficiente.
 */
export const TrackedPreviewButton = () => {
  const [showPanel, setShowPanel] = useState(false);
  const trackedProducts = useRestockedTrackedProducts();

  const modalRef = useRef(null);
  useClickOutside(modalRef, () => setShowPanel(false));

  const restockedCount = trackedProducts.restocked.length;

  return (
    <div>
      <ItemsCounter
        data-count={restockedCount}
        hideBadge={restockedCount === 0}
        onClick={() => {
          if (!showPanel) {
            trackedProducts.refresh();
          }
          setShowPanel(true);
        }}>
        <BookmarksOutlined fontSize="large" className="text-primary" />
      </ItemsCounter>
      {
        showPanel && (
          <Content ref={modalRef}>
            <CloseBtnContainer onClick={() => setShowPanel(false)}>
              <CloseIcon />
            </CloseBtnContainer>
            <TrackedPreview trackedProducts={trackedProducts} setShowPanel={setShowPanel} />
          </Content>
        )}
    </div>
  );
};
